export const schedule = {
  data: [
    {
      displayText: 'Now',
      value: 'Now',
    },
    {
      displayText: 'End of Month',
      value: 'End of Month',
    },
    {
      displayText: 'End of Year',
      value: 'End of Year',
    },
    {
      displayText: 'Custom Schedule',
      value: 'Custom Schedule',
    },
  ],
}
